export enum MultiselectTheme {
  blueTransparent = 'blueTransparent',
  classic = 'classic',
  classicRounded = 'classicRounded',
  darkTransparent = 'darkTransparent',
  transparent = 'transparent'
}
